import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useResultCardStyles = makeStyles(() => ({
  resultCard: {
    position: 'relative',
    backgroundColor: colors.white,
    borderRadius: radius.sm,
    overflow: 'hidden',
  },
  resultCardInner: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    padding: `${spacing.md}px ${spacing.sm}px`,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: 50,
      padding: `${spacing.md}px 40px`,
    },
  },
  resultCardVisual: {
    width: '100%',
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      width: 440,
      maxWidth: '40%',
    },
  },
  resultCardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    flex: 1,
    alignItems: 'stretch',
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      alignItems: 'flex-end',
      justifyContent: 'space-between',
    },
  },
  resultDescription: {
    margin: 0,
    width: '100%',
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.overlay,
    lineHeight: 1.8,
  },
  resultButton: {
    ...primaryButtonStyle,
    alignSelf: 'flex-end',
  },
  resultButtonDisabled: {
    backgroundColor: colors.placeholder,
    cursor: 'not-allowed',
  },
  resultButtonIcon: {
    width: 16,
    height: 16,
    color: colors.white,
  },
  resultCardContent: {
    width: '100%',
    filter: 'none',
  },
  resultCardContentInactive: {
    filter: 'grayscale(0.9)',
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 5,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  overlayHidden: {
    display: 'none',
  },
  overlayModal: {
    width: '90%',
    maxWidth: 400,
    padding: `${spacing.md}px ${spacing.lg}px`,
    backgroundColor: colors.white,
    borderRadius: radius.md,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.sm,
  },
  overlayTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.intro,
    color: colors.textBody,
    textAlign: 'center',
    lineHeight: 1.4,
  },
  overlayButton: {
    marginTop: spacing.xs,
    padding: '12px 32px',
    borderRadius: 4,
    border: 0,
    backgroundColor: colors.primary,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    textTransform: 'none',
    '&:hover': {
      opacity: 0.9,
    },
  },
  cardLoader: {
    minHeight: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
